import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * Toast global store.
 * Uso: const toast = useToastStore()
 *      toast.success('KYC aprobado')
 *      toast.error('No hemos podido guardar. Inténtalo de nuevo.')
 *      toast.info('Perfil actualizado')
 */
export const useToastStore = defineStore('toast', () => {
  const toasts = ref([])

  function add(message, type = 'info', duration = 4500) {
    const id = Date.now() + Math.random()
    toasts.value.push({ id, message, type })
    if (duration > 0) {
      setTimeout(() => remove(id), duration)
    }
    return id
  }

  function remove(id) {
    toasts.value = toasts.value.filter((t) => t.id !== id)
  }

  function success(msg, duration) {
    return add(msg, 'success', duration)
  }

  function error(msg, duration) {
    return add(msg, 'error', duration)
  }

  function info(msg, duration) {
    return add(msg, 'info', duration)
  }

  function warning(msg, duration) {
    return add(msg, 'warning', duration)
  }

  return { toasts, add, remove, success, error, info, warning }
})
